export const formatUrl = (urlPattern, ...args) => {
  return urlPattern.replace(/{(\d+)}/g, (match, index) => {
    return args[index] !== undefined ? args[index] : match;
  });
};
